import { useRef, useState } from "react"
import Input from "../../UI/Input"

import classes from "./MealItemForm.module.css"

const MealItemForm = (props) => {
	const [amountIsValid, setAmountIsValid] = useState(true)
	const amountInputRef = useRef()

	const submitHandler = (e) => {
		e.preventDefault()

		const enteredAmount = amountInputRef.current.value
		const enteredAmountNumb = +enteredAmount

		if (
			enteredAmount.trim().length === 0 ||
			enteredAmountNumb < 1 ||
			enteredAmountNumb > 5
		) {
			setAmountIsValid(false)
			return
		}
		props.onAddToCart(enteredAmountNumb)
	}

	return (
		<form className={classes.form} onSubmit={submitHandler}>
			<Input
				ref={amountInputRef}
				label='Amount'
				input={{
					id: `amount_${props.id}`,
					type: "number",
					min: "1",
					max: "5",
					step: "1",
					defaultValue: "5",
				}}
			/>
			<button>+ Add</button>
			{!amountIsValid && <p>Pleas enter a valid amount (1-5).</p>}
		</form>
	)
}

export default MealItemForm
